import { FormlyFieldConfig } from "@ngx-formly/core";
import { FieldDefinitionConditions } from "../../../../../../sections/medicinalProduct/message/fieldDefinition-conditions";
import { FieldDefinitionFields } from "../../../../../../sections/medicinalProduct/message/fieldDefinition-fields";
import { Injector } from "@angular/core";
import { EntityEnum } from "../../../EntityEnum";
import { MedicinalProductsQueryNode } from "../../MedicinalProductsQueryNode";
import { Art57Section } from "../../../../Art57Section/Art57Section";
import { AutoUploadEntityEnum as AutoUploadEntityEnum } from "../../../../AutoUploadEntityEnum";
import { TreeNodeSubstancesList } from "../../../Art57Node/ListEntity/TreeNodeSubstancesList";

export class DevelopmentSubstanceQueryNode extends MedicinalProductsQueryNode {
    constructor(injector: Injector) {
    const queryFields: FormlyFieldConfig[] =  new FieldDefinitionFields(injector).developmentSubstancesFields;
    const createChidTemplateParams = {nodeTypeToCreateName: 'addDevelopmentSubstance'};
    const queryConditions: FormlyFieldConfig[] = new FieldDefinitionConditions(injector).developmentSubstancesConditions;
       super(injector, [], 'Development Substances', EntityEnum.developmentSubstance,  queryFields, queryConditions, injector.get(Art57Section).medicinalProduct.developmentSubstanceTreeNode, TreeNodeSubstancesList, AutoUploadEntityEnum.developmentSubstance, createChidTemplateParams);    
    }
}